"use client"

import type { ReactNode } from "react"

import { Link } from "@/i18n/navigation"
import { useCategoryHashNav } from "@/components/use-category-hash-nav"

/**
 * Desktop category quick-nav link for StoreHeader. A locale-aware Link to
 * `/menu#category-<id>` whose click is intercepted by {@link useCategoryHashNav}
 * so that re-selecting a category while already on `/menu` replaces the URL
 * fragment instead of appending to it. Client component; the header (a Server
 * Component) renders it with the category icon + name as children.
 */
export function CategoryLink({
  categoryId,
  className,
  children,
}: {
  categoryId: string
  className?: string
  children: ReactNode
}) {
  const onClick = useCategoryHashNav()
  return (
    <Link
      href={`/menu#category-${categoryId}`}
      className={className}
      onClick={onClick(categoryId)}
    >
      {children}
    </Link>
  )
}
